import React, { useState } from "react";
import GetYoutubeID, { GetYoutubeIDFromShorts } from "lib/GetYoutubeID";
import {ReactComponent as SVGPlay} from '../../assets/play-circle-outline.svg';
import {ReactComponent as SVGLove} from '../../assets/love.svg';
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import update from "immutability-helper";
import api from "api";
import "./index.scss";

const ComponentExperience = connect(stateMap)((props) => {
    const [experience, setExperience] = useState(props.experience);

    const months = ['', 'Januari', 'Februari', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    const DisplayExperienceTimeframe = () => {
        if(props.experience.ExpIsCurrent > 0)
        {
            if(props.experience.ExpStartYear > 0)
            {
                if(props.experience.ExpStartMonth > 0)
                {
                    return months[props.experience.ExpStartMonth] + ' ' + props.experience.ExpStartYear + ' - Present';
                }
                else
                {
                    return props.experience.ExpStartYear + ' - Present';
                }
            }
            else
            {
                return 'Present';
            }
        }
        else
        {
            if(props.experience.ExpStartYear > 0 && props.experience.ExpEndYear > 0)
            {
                if(props.experience.ExpStartYear == props.experience.ExpEndYear)
                {
                    if(props.experience.ExpStartMonth > 0 && props.experience.ExpEndMonth > 0)
                    {
                        if(props.experience.ExpStartMonth == props.experience.ExpEndMonth)
                        {
                            return months[props.experience.ExpStartMonth] + ' ' + props.experience.ExpStartYear;
                        }
                        else
                        {
                            return months[props.experience.ExpStartMonth] + ' - ' + months[props.experience.ExpEndMonth] + ' ' + props.experience.ExpStartYear;
                        }
                    }
                    else if(props.experience.ExpStartMonth > 0)
                    {
                        return months[props.experience.ExpStartMonth] + ' ' + props.experience.ExpStartYear;
                    }
                    else
                    {
                        return months[props.experience.ExpEndMonth] + ' ' + props.experience.ExpStartYear;
                    }
                }
                else
                {
                    if(props.experience.ExpStartMonth > 0 && props.experience.ExpEndMonth > 0)
                    {
                        return months[props.experience.ExpStartMonth] + ' ' + props.experience.ExpStartYear  + ' - ' + months[props.experience.ExpEndMonth] + ' ' + props.experience.ExpEndYear;
                    }
                    else if(props.experience.ExpEndMonth > 0)
                    {
                        return props.experience.ExpStartYear  + ' - ' + months[props.experience.ExpEndMonth] + ' ' + props.experience.ExpEndYear;
                    }
                    else
                    {
                        return months[props.experience.ExpStartMonth] + ' ' + props.experience.ExpStartYear  + ' - ' + props.experience.ExpEndYear;
                    }
                }
            }
            else if(props.experience.ExpStartYear > 0)
            {
                if(props.experience.ExpStartMonth > 0)
                {
                    return months[props.experience.ExpStartMonth] + ' ' + props.experience.ExpStartYear;
                }
                else
                {
                    return props.experience.ExpStartYear;
                }
            }
            else
            {
                if(props.experience.ExpEndMonth > 0)
                {
                    return months[props.experience.ExpEndMonth] + ' ' + props.experience.ExpEndYear;
                }
                else
                {
                    return props.experience.ExpEndYear;
                }
            }
        }
    }

    return (
        <div className="wrapper component-experience">
            <h3 className="exp-title bold">{props.experience.ExpTitle}</h3>
            <span className="exp-date block text-xs">
                {  DisplayExperienceTimeframe() }
            </span>
            {
                props.auth.user.UserID !== props.experience.ExpOwnerID && 
                <div className="experience-crowd-actions">
                    <span className="crowd-actions" onClick={e => {
                        e.preventDefault();

                        if(!props.auth.token)
                        {
                            return;
                        }

                        setExperience(update(experience, {
                            loving : {
                                $set : true
                            }
                        }));

                        api('/Experience/Like', 'get', {
                            exp_id : props.experience.ExpID
                        }, 'Bearer ' + props.auth.token)
                            .then(response => {
                                setExperience(update(experience, {
                                    loving : {
                                        $set : false
                                    }
                                    ,ExpLikes : {
                                        $set : response.likes
                                    }
                                }));
                            })

                    }}>
                        {
                            experience.loving ?
                            <span className="skeleton"></span> :
                            <SVGLove/> 
                        }
                        {experience.ExpLikes} Likes
                    </span>
                </div>
            }
            <div className="leading-text exp-desc" dangerouslySetInnerHTML={{__html : props.experience.ExpDescHTML }}/>
            <div className="experience-medias">
                {
                    props.experience.ExpMedias.map((media) => (
                        media.ExpMediaType !== 'website' && (
                            <div className="experience-media" key={media.ExpMediaURL}>
                                <div className="wrapper">
                                        {
                                            media.ExpMediaType === 'image' &&
                                            <a href={media.ExpMediaURL} target="_blank" data-src={media.ExpMediaURL} data-fancybox="" className="image-box">
                                                <img src={media.ExpMediaURL}/>
                                            </a>
                                        }
                                        {
                                            media.ExpMediaType === 'youtube' && 
                                            (
                                                GetYoutubeIDFromShorts(media.ExpMediaURL) ?
                                                (
                                                    <a href={media.ExpMediaURL} target="_blank"  className="image-box">
                                                        <img src={`https://img.youtube.com/vi/${GetYoutubeID(media.ExpMediaURL)}/mqdefault.jpg`}/>
                                                        <span className="icon-play">
                                                            <SVGPlay/>
                                                        </span>
                                                    </a>   
                                                )
                                                :
                                                (
                                                    <a href={media.ExpMediaURL} target="_blank" data-src={media.ExpMediaURL} data-fancybox=""  className="image-box">
                                                        <img src={`https://img.youtube.com/vi/${GetYoutubeID(media.ExpMediaURL)}/mqdefault.jpg`}/>
                                                        <span className="icon-play">
                                                            <SVGPlay/>
                                                        </span>
                                                    </a>   
                                                )
                                            )
                                        }
                                </div>
                            </div>
                        )
                    ))
                }
            </div>
            <div className="experience-links">
            {
                    props.experience.ExpMedias.map((media) => (
                        media.ExpMediaType === 'website' && (
                            <div className="experience-link" key={media.ExpMediaURL}>
                                <a href={media.ExpMediaURL} className="btn btn-mini btn-reverse">{media.ExpMediaURL}</a>
                            </div>
                        )
                    ))
                }
            </div>
            {props.children}
        </div>
    )
})

export default ComponentExperience;